'use strict';
import React from 'react';
import flux from 'utils/flux';
import HeaderDropdown from './headerDropdown'

var HeaderLanguageSelection = React.createClass({

    displayName: 'HeaderLanguageSelection',

    switchLanguage(language, e) {
        e.preventDefault();
        flux.getStore('translations').switchLanguage(language);
    },
    render() {
        const { config } = flux.getStore('app').getState();
        const { enableLanguageSelection } = config.toJS();

        const availableLanguages = flux.getStore('translations').getAvailableLanguages() || [];
        const userLanguage = flux.getStore('translations').getUserLocale() || 'EN';

        if (!!enableLanguageSelection) {
            return (
                <span className="header__language-selection">
                    <HeaderDropdown
                        label={flux.t('switch_languages')}>
                        <ul>
                            {availableLanguages.map( ( langDef, ix ) => {
                                return (
                                    <li>
                                        <i className="play "></i>
                                        <a className={"" + (userLanguage === langDef.id ? 'active' : '')} href="#" onClick={this.switchLanguage.bind(null, langDef.id)}>{langDef.name}</a>
                                    </li>
                                );
                            })}
                        </ul>
                    </HeaderDropdown>
                </span>
            );
        } else {
            return (<span/>);
        }
    }
});

module.exports = HeaderLanguageSelection;



// WEBPACK FOOTER //
// ./app/components/header/headerLanguageSelection.jsx